/** @format */
import {
  useAppDispatch,
  useAppSelector,
} from "src/store/hook.js";
import { useLocation, useNavigate } from "react-router-dom";
import { setRefreshToken, signInSuccess, signOutSuccess } from "../../store";
import * as Selector from "src/store/auth/selector";
import appConfig from "../../configs/app.config";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";

function useAuth() {
  const dispatch = useDispatch();
  const location = useLocation();

  const navigate = useNavigate();

  const { token } = useAppSelector(Selector.token) || {};
  const { signedIn } = useAppSelector(Selector.signedIn) || {};

  const successfulSignIn = (resp) => {
    const { id, token, email } = resp.data;

    const decoded = jwtDecode(token);

    dispatch(signInSuccess(token));

    const redirectUrl = new URLSearchParams(location.search).get("redirectUrl");
    navigate(redirectUrl ? redirectUrl : appConfig.authenticatedAdminEntryPath);
  };

  const successfulUserSignIn = (resp) => {
    console.log(resp);
    const { access_token } = resp.data;
    const { refresh_token } = resp.data;
    console.log(access_token);
    dispatch(signInSuccess(access_token));
    dispatch(setRefreshToken(refresh_token));
    navigate("/u/jobs");
  };

  const successfulEmployerSignIn = (resp) => {
    console.log(resp);
    const { access_token } = resp.data;
    const { refresh_token } = resp.data;
    console.log(access_token);
    dispatch(signInSuccess(access_token));
    dispatch(setRefreshToken(refresh_token));
    navigate("/e");
  };

  return {
    authenticated: token && signedIn,

    successfulSignIn,
    successfulUserSignIn,
    successfulEmployerSignIn,
  };
}

export default useAuth;
